export default "__VITE_ASSET__917ba80e__"